import React from 'react';
import { Modal } from '../../../../components/containers/Modal';
import { Void } from '../../../../models/basic-objects';
import { ConnectProfileOAuthType } from '../Profiles.controller';
import { profilesHelpers } from '../Profiles.helpers';

export type AlreadyConnectedModalViewProps = {
  //
  loading: boolean;
  cancelConnect: Void;
  content: JSX.Element;
  oAuthConnectObject: ConnectProfileOAuthType;
};

export const AlreadyConnectedModalView = (props: AlreadyConnectedModalViewProps): JSX.Element => {
  return (
    <Modal
      closeOnClickOutside={!props.loading}
      closeOnEsc={!props.loading}
      onClose={() => props.cancelConnect()}
      showCloseIcon={!props.loading}
      title={'Connect another Profile?'}
      primaryButtonTitle={'Try again'}
      primaryButtonAction={() => profilesHelpers.setNetworkAndCallOAuth(props.oAuthConnectObject)}
      primaryButtonDisabled={props.loading}
      primaryButtonLoading={props.loading}>
      {props.content}
    </Modal>
  );
};
